<template>
    <sa-page-layout slot="table-body" :btnConfigurazioniVisible="btnConfigurazioniVisible" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :showModalLoading="showModalLoading" :linkConfigurazioni="linkConfigurazioni">
        <template slot="toolbar">
            <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm" @click="onClickNuovoTipoImpegnativa">
                <b-icon icon="plus"></b-icon>
                Nuovo
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Tipo</label>
                        <b-form-input v-model="filtroImpegnativa.tipo" type="search" id="tipo" placeholder="Inserire tipo impegnativa"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Codice Flusso</label>
                        <b-form-input v-model="filtroImpegnativa.codiceFlusso" type="search" placeholder="Inserire codice flusso"></b-form-input>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                        <b-button type="submit" variant="info"> {{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>
        </template>
        <template slot="table-body">
            <rsa-configurazione-tipo-impegnativa-list-component ref="RsaConfigurazioneTipoImpegnativaListComponent" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" @updateFilter="onUpdateFilter" />
        </template>
    </sa-page-layout>
</template>
<script>
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaConfigurazioneTipoImpegnativaListComponent from "../components/RsaConfigurazioneTipoImpegnativaListComponent.vue";
export default {
    components: { SaPageLayout, RsaConfigurazioneTipoImpegnativaListComponent },

    data() {
        return {
            filtroImpegnativa: {
                tipo: null,
                codiceFlusso: null,
            },
            btnNewVisible: false,
            btnConfigurazioniVisible: true,
            pathResource: "",
            linkConfigurazioni: "/configurazioni",
            showModalLoading: false,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
        let sessionStorage = window.sessionStorage;
        if (sessionStorage["filtroImpegnativa"]) {
            me.filtroImpegnativa = JSON.parse(sessionStorage["filtroImpegnativa"]);
        }
    },
    methods: {
        loadData() {
            let me = this;
            me.$refs.RsaConfigurazioneTipoImpegnativaListComponent.loadData();
        },
        onBeforeLoadData() {
            this.showModalLoading = true;
        },
        onAfterLoadData() {
            this.showModalLoading = false;
        },
        onSubmit() {
            let me = this;
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroImpegnativa"] = JSON.stringify(me.filtroImpegnativa);
            me.loadData();
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onReset() {
            let me = this;
            me.filtroImpegnativa = { tipo: null, codiceFlusso: null };
            let sessionStorage = window.sessionStorage;
            sessionStorage["filtroImpegnativa"] = JSON.stringify(me.filtroImpegnativa);
            me.loadData();
        },
        onClickNuovoTipoImpegnativa() {
            let me = this;
            me.$refs.RsaConfigurazioneTipoImpegnativaListComponent.onClickNuovoTipoImpegnativa();
        },
        onUpdateFilter(filterData) {
            let me = this;
            me.filtroImpegnativa = filterData;
        },
    },
};
</script>
